import React, { useEffect } from "react";
import Button from "../../components/Button";
import Select from "react-select";

import "./styles.css";
import UsersColl from "../../firebase/UsersColl";
import Footer from "../../components/Footer";

export default function CreateAccount() {
  const [user, setUser] = React.useState({
    first_name: "",
    last_name: "",
    display_name: "",
    digital_sig: "",
    email: "",
    phone: "",
    organization: "808_cleanups",
    active_organization: "808_cleanups",
    organizations: ["808_cleanups"],
    ethnicity: "unknown",
    app_version: "web",
    cleanup_types: [],
    create_date: new Date(),
    ohana_agr_read: true,
    password: "",
    confirmPassword: "",
    include_dir: true
  });

  const [errors, setErrors] = React.useState({
    email: "",
    phone: "",
    password: ""
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\d{10}$/; // Example: 10-digit phone number
    return phoneRegex.test(phone);
  };

  const handleProceed = async (user) => {
    const { email, phone, password, confirmPassword } = user;

    // Reset errors
    setErrors({ email: "", phone: "", password: "" });

    // Validate email
    if (!validateEmail(email)) {
      setErrors((prev) => ({ ...prev, email: "Invalid email format." }));
      return;
    }

    // Validate phone
    if (!validatePhone(phone)) {
      setErrors((prev) => ({
        ...prev,
        phone: "Invalid phone number format. Use 10 digits."
      }));
      return;
    }

    // Validate passwords
    if (password !== confirmPassword) {
      setErrors((prev) => ({ ...prev, password: "Passwords do not match." }));
      return;
    }

    let userRecord = { ...user };
    delete userRecord.confirmPassword;
    delete userRecord.password;
    let success = await UsersColl.shared.registerAndCreateUser(
      userRecord,
      password
    );
    if (success) {
      // Dispatch a custom event that NavBar can listen for
      window.dispatchEvent(new Event("userLogin"));
      window.location.href = "/dashboard";
    } else {
      alert("Failed to create account. Please try again.");
    }
  };

  return (
    <div>
      <h1>Create Account</h1>
      <div className="create-account-container">
        <div className="form-card">
          <p className="form-description">
            Aloha, please fill out the form below to create your 808 Cleanups
            account!
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleProceed(user);
            }}
          >
            <div className="form-group">
              <label htmlFor="first_name">First Name</label>
              <input
                type="text"
                id="first_name"
                value={user.first_name}
                onChange={(e) =>
                  setUser({ ...user, first_name: e.target.value })
                }
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="last_name">Last Name</label>
              <input
                type="text"
                id="last_name"
                value={user.last_name}
                onChange={(e) =>
                  setUser({ ...user, last_name: e.target.value })
                }
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="publicName">Public Name</label>
              <input
                type="text"
                id="publicName"
                value={user.display_name}
                onChange={(e) =>
                  setUser({
                    ...user,
                    display_name: e.target.value,
                    digital_sig: e.target.value
                  })
                }
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={user.email}
                onChange={(e) => setUser({ ...user, email: e.target.value })}
                required
              />
              {errors.email && <p className="error-message">{errors.email}</p>}
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                value={user.phone}
                onChange={(e) => setUser({ ...user, phone: e.target.value })}
                required
              />
              {errors.phone && <p className="error-message">{errors.phone}</p>}
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={user.password}
                onChange={(e) => setUser({ ...user, password: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={user.confirmPassword}
                onChange={(e) =>
                  setUser({ ...user, confirmPassword: e.target.value })
                }
                required
              />
              {errors.password && (
                <p className="error-message">{errors.password}</p>
              )}
            </div>
            <p className="form-note">
              I understand that any of the information I supply may be displayed
              publicly on 808cleanups.org and on the 808 Cleanups Mobile App.
            </p>
            <p>
              By clicking "Create Account" you are acknowledging that you read
              and agree to the{" "}
              <a target="_blank" href="https://808cleanups.org/waiver/">
                808 Cleanup's Insurance Waiver
              </a>
              .
            </p>
            <Button
              type="submit"
              color="primary"
              className="form__custom-button"
            >
              Create Account
            </Button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
